import { APITagType } from './invisibly-api.types';

const {
  BrandOffer, InsertionOrder, MagazineTitle, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, CampaignAIReporter, PulsePollingConfig, OrganizationClients,
} = APITagType;

export const ALL_API_TAG_TYPES: APITagType[] = [BrandOffer, InsertionOrder, MagazineTitle, SuspensionReason, YodleeBankAccount, YodleeToken, Summaries, CampaignAIReporter, PulsePollingConfig, OrganizationClients];
